<template>
    <div>
        <rkm-modal
            :extra-large="showCalendar"
            persistent
            ref="RkmModal"
            title="Cadastro de agendamento"
        >
            <rkm-form
                v-if="model"
                ref="RkmFormCadastro"
                show-legend
            >
                <rkm-row>
                    <rkm-col :cols="showCalendar ? 5 : 12">
                        <rkm-row>
                            <rkm-col>
                                <rkm-form-select
                                    :options="form.unidades"
                                    :validations="validations.unidade"
                                    @change="handleUnidadeChange"
                                    label="Unidade"
                                    show-default-option
                                    text-field="nomeFantasia"
                                    v-model="model.unidadeId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-select
                                    :options="form.infraestruturas"
                                    :validations="validations.infraestrutura"
                                    @change="handleInfraestruturaChange"
                                    label="Local de atendimento"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.infraestruturaId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-select
                                    :options="form.ocupacoes"
                                    :validations="validations.ocupacao"
                                    @change="handleOcupacaoChange"
                                    label="CBO"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="model.ocupacaoId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-select
                                    :options="form.especialidades"
                                    :validations="validations.especialidade"
                                    @change="handleEspecialidadeChange"
                                    label="Especialidade"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.especialidadeId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-select
                                    :options="form.usuarios"
                                    :validations="validations.usuario"
                                    @change="handleUsuarioChange"
                                    label="Profissional"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.usuarioId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-select
                                    :options="form.tipos"
                                    :validations="validations.tipo"
                                    @change="handleTipoChange"
                                    label="Tipo"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.tipoId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>

                    <rkm-col
                        v-if="showCalendar"
                        class="mt-1"
                        cols="7"
                    >
                        <rkm-calendar
                            :items="feriados.concat(datasBloqueadas).concat(datasComAgendamentoAmbulatorio).concat(datas)"
                            @click="handleCalendarioClick"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <template v-slot:footer="{cancel}">
                <rkm-button @click="cancel">
                    Fechar
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalHorario
            v-if="model"
            :data="{additionals, form, model}"
            :paciente="paciente"
            :paciente-id="pacienteId"
            @saved="hide"
            ref="ModalHorario"
        />

        <ModalSupervisorValidadeNovoAgendamento
            @authorized="authorizedSupervisorValidadeNovoAgendamento"
            ref="ModalSupervisorValidadeNovoAgendamento"
        />
    </div>
</template>

<script>
// Components.
import ModalHorario from './components/horario/Modal'
import ModalSupervisorValidadeNovoAgendamento from '@/components/ambulatorio/components/supervisor/Modal'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {
        ModalHorario,
        ModalSupervisorValidadeNovoAgendamento,
    },
    computed: {
        feriados() {
            return this.form.feriados.map(feriado => {
                return {
                    dates: this.others.moment(feriado.data, 'DD/MM/YYYY'),
                    highlight: 'yellow',
                    popover: feriado.observacao,
                    title: feriado.tipoDescricao,
                }
            })
        },
        datasBloqueadas() {
            return this.form.datasBloqueadas.map(dataBloqueada => {
                return {
                    dates: this.others.moment(dataBloqueada, 'DD/MM/YYYY'),
                    highlight: 'red',
                    title: 'Bloqueada',
                }
            })
        },
        datasComAgendamentoAmbulatorio() {
            const especialidade = this.form.especialidades.find(especialidade => especialidade.id === this.model.especialidadeId)

            if (especialidade && (especialidade.tratamento === false || (especialidade.tratamento === true && especialidade.permiteAgendamentoMesmoDia === false))) {
                return this.form.datasComAgendamento.ambulatorio
                    .filter(dataComAgendamentoAmbulatorio => dataComAgendamentoAmbulatorio.especialidadeId === this.model.especialidadeId)
                    .map(dataComAgendamentoAmbulatorio => {
                        return {
                            dates: this.others.moment(dataComAgendamentoAmbulatorio.data, 'DD/MM/YYYY'),
                            highlight: 'blue',
                            popover: `O paciente já possui um agendamento nesta data para o horário ${dataComAgendamentoAmbulatorio.horario}`,
                            title: 'Agendado',
                        }
                    })
            }

            return []
        },
        datas() {
            return this.form.datas.map(data => {
                return {
                    dates: this.others.moment(data.data, 'DD/MM/YYYY'),
                    highlight: data.quantidadeAgendada >= data.quantidadeTotal ? 'red' : 'green',
                    title: `${data.quantidadeAgendada} / ${data.quantidadeTotal}`,
                }
            })
        },
        ...mapGetters({'lotacao': 'getLotacao'}),
        validations() {
            return {
                unidade: {required: true},
                infraestrutura: {required: true},
                ocupacao: {required: true},
                especialidade: {required: true},
                usuario: {required: true},
                tipo: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            agendamentoRetroativo: this.getConectaSusRepository('ambulatorio.agendamentoRetroativo'),
        }
    },
    data: () => ({
        additionals: null,
        form: null,
        model: null,
        others: {moment},
        showCalendar: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.tipos = []
            this.model.infraestruturaId = null
            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.tipoId = null
            this.showCalendar = false

            if (value === null) return

            this.getInfraestruturas(value)
        },
        handleInfraestruturaChange(value) {
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.tipos = []
            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.tipoId = null
            this.showCalendar = false

            if (value === null) return

            this.getOcupacoes(value)
        },
        handleOcupacaoChange(value) {
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.tipos = []
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.tipoId = null
            this.showCalendar = false

            if (value === null) return

            this.getEspecialidades(this.model.infraestruturaId, value)
        },
        handleEspecialidadeChange(value) {
            this.form.usuarios = []
            this.form.tipos = []
            this.model.usuarioId = null
            this.model.tipoId = null
            this.showCalendar = false

            if (value === null) return

            this.getUnidadePaciente(this.model.infraestruturaId, value)
        },
        handleUsuarioChange(value) {
            this.form.tipos = []
            this.model.tipoId = null
            this.showCalendar = false

            if (value === null) return

            this.getTipos(this.model.infraestruturaId, this.model.ocupacaoId, this.model.especialidadeId, value)
        },
        handleTipoChange(value) {
            this.showCalendar = false

            if (value === null) return

            this.getDatas(this.model.infraestruturaId, this.model.ocupacaoId, this.model.especialidadeId, this.model.usuarioId, value)
        },
        create() {
            this.setLoading()

            this.form = null
            this.model = null
            this.showCalendar = false

            this.$refs.RkmModal.show()

            this.repositories.agendamentoRetroativo.create(this.pacienteId, this.camelObjectKeysToSnakeRecursive({origem: 'cadastro'}))
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)

                    if (this.additionals.enderecoDesatualizadoBloqueado) {

                        this.$refs.RkmModal.hide()

                        this.showAlert(
                            'O endereço do paciente ainda não foi atualizado pela Base Nacional. Atualize o cadastro para continuar.',
                            'Atenção'
                        )

                        return
                    }

                    const proceed = () => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)

                        this.$nextTick().then(() => this.$refs.RkmFormCadastro.resetValidator())
                    }

                    if (this.additionals.diasCadastroDesatualizado > 0) {

                        let msg = `Paciente com cadastro desatualizado há <strong>${this.additionals.diasCadastroDesatualizado}</strong> dia(s). Deseja continuar?`

                        if (!this.additionals.isOrigemBaseNacional) {

                            msg = `Paciente com cadastro desatualizado há <strong>${this.additionals.diasCadastroDesatualizado}</strong> dia(s). Endereço do usuário também deve ser atualizado. Deseja continuar?`
                        }

                        this.showConfirmation(
                            msg,
                            async () => proceed(),
                            async () => this.$refs.RkmModal.hide()
                        )
                    } else {

                        proceed()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleCalendarioClick(value) {
            const especialidade = this.form.especialidades.find(especialidade => especialidade.id === this.model.especialidadeId)

            let data = this.form.datas
                .filter(data => !this.form.feriados.find(feriado => feriado.data === data.data))
                .filter(data => !this.form.datasBloqueadas.find(dataBloqueada => dataBloqueada === data.data))

            if (especialidade.tratamento === false || (especialidade.tratamento === true && especialidade.permiteAgendamentoMesmoDia === false)) {
                data = data.filter(data => {
                    return !this.form.datasComAgendamento.ambulatorio
                        .filter(dataComAgendamentoAmbulatorio => dataComAgendamentoAmbulatorio.especialidadeId === this.model.especialidadeId)
                        .find(dataComAgendamentoAmbulatorio => dataComAgendamentoAmbulatorio.data === data.data)
                })
            }

            data = data.find(data => this.others.moment(data.data, 'DD/MM/YYYY').isSame(value.date))

            if (data) {
                if (this.isDentroValidadeNovoAgendamento(value.date)) {
                    this.showConfirmation(
                        `A consulta excede o limite permitido de agendamento dentro do período, podendo ser agendada
                        à partir da data de <strong>${this.form.dataMinimaValidadeNovoAgendamento}</strong>.
                        Para continuar o agendamento é necessário autorização de supervisor. Deseja continuar?`,
                        async () => {

                            await this.$nextTick()
                            this.$refs.ModalSupervisorValidadeNovoAgendamento.open({
                                date: value.date,
                                infraestruturaId: this.model.infraestruturaId,
                                lotacaoInfraestruturaId: this.lotacao.infraestruturaId,
                            })
                        }
                    )
                } else {
                    this.openModalHorario(value.date)
                }
            }
        },
        isDentroValidadeNovoAgendamento(date) {
            if (!this.form.dataMinimaValidadeNovoAgendamento) return false

            return this.others.moment(date).isBefore(this.others.moment(this.form.dataMinimaValidadeNovoAgendamento, 'DD/MM/YYYY'), 'day')
        },
        authorizedSupervisorValidadeNovoAgendamento(data) {
            this.openModalHorario(data.date)
        },
        openModalHorario(date) {
            this.$refs.ModalHorario.open(
                this.model.infraestruturaId,
                this.model.ocupacaoId,
                this.model.especialidadeId,
                this.model.usuarioId,
                this.model.tipoId,
                this.others.moment(date).format('DD/MM/YYYY'),
            )
        },
        hide() {
            const especialidade = this.form.especialidades.find(especialidade => especialidade.id === this.model.especialidadeId)

            if (especialidade.tratamento === false) {
                this.$refs.RkmModal.hide()
            }
            else {
                this.getDatas(this.model.infraestruturaId, this.model.ocupacaoId, this.model.especialidadeId, this.model.usuarioId, this.model.tipoId)
            }
        },
        async getInfraestruturas(unidadeId) {
            const request = {
                origem: 'cadastro',
                listar: 'infraestruturas',
                pacienteId: this.pacienteId,
                unidadeId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.agendamentoRetroativo.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.infraestruturas = Object.assign(response.data.infraestruturas)

                if (this.form.infraestruturas.length === 1) {
                    const selected = this.form.infraestruturas[0]
                    this.model.infraestruturaId = selected.id

                    this.getOcupacoes(this.model.infraestruturaId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getOcupacoes(infraestruturaId) {
            const request = {
                origem: 'cadastro',
                listar: 'ocupacoes',
                pacienteId: this.pacienteId,
                infraestruturaId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.agendamentoRetroativo.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.ocupacoes = Object.assign(response.data.ocupacoes)

                if (this.form.ocupacoes.length === 1) {
                    const selected = this.form.ocupacoes[0]
                    this.model.ocupacaoId = selected.id

                    this.getEspecialidades(infraestruturaId, this.model.ocupacaoId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getEspecialidades(infraestruturaId, ocupacaoId) {
            const request = {
                origem: 'cadastro',
                listar: 'especialidades',
                pacienteId: this.pacienteId,
                infraestruturaId,
                ocupacaoId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.agendamentoRetroativo.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.especialidades = Object.assign(response.data.especialidades)

                if (this.form.especialidades.length === 1) {
                    const selected = this.form.especialidades[0]
                    this.model.especialidadeId = selected.id

                    this.getUnidadePaciente(infraestruturaId, this.model.especialidadeId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getUnidadePaciente(infraestruturaId, especialidadeId) {
            this.setLoading()

            try {
                const {data} = await this.repositories.agendamentoRetroativo.unidadePaciente(this.pacienteId, infraestruturaId, especialidadeId)

                if (data.unidadeComJornada) {
                    this.showConfirmation(
                        `Paciente pertence à unidade ${data.unidade}, deseja continuar com o agendamento?`,
                        async () => this.getUsuarios(infraestruturaId, this.model.ocupacaoId, especialidadeId),
                        async () => this.model.especialidadeId = null
                    )
                } else {
                    this.getUsuarios(infraestruturaId, this.model.ocupacaoId, especialidadeId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getUsuarios(infraestruturaId, ocupacaoId, especialidadeId) {
            const request = {
                origem: 'cadastro',
                listar: 'usuarios',
                pacienteId: this.pacienteId,
                infraestruturaId,
                ocupacaoId,
                especialidadeId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.agendamentoRetroativo.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.usuarios = Object.assign(response.data.usuarios)

                if (this.form.usuarios.length === 1) {
                    const selected = this.form.usuarios[0]
                    this.model.usuarioId = selected.id

                    this.getTipos(infraestruturaId, ocupacaoId, especialidadeId, this.model.usuarioId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getTipos(infraestruturaId, ocupacaoId, especialidadeId, usuarioId) {
            const request = {
                origem: 'cadastro',
                listar: 'tipos',
                pacienteId: this.pacienteId,
                infraestruturaId,
                ocupacaoId,
                especialidadeId,
                usuarioId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.agendamentoRetroativo.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.tipos = Object.assign(response.data.tipos)

                if (this.form.tipos.length === 1) {
                    const selected = this.form.tipos[0]
                    this.model.tipoId = selected.id

                    this.getDatas(infraestruturaId, ocupacaoId, especialidadeId, usuarioId, this.model.tipoId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getDatas(infraestruturaId, ocupacaoId, especialidadeId, usuarioId, tipoId) {
            const request = {
                origem: 'cadastro',
                listar: 'datas',
                pacienteId: this.pacienteId,
                infraestruturaId,
                ocupacaoId,
                especialidadeId,
                usuarioId,
                tipoId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.agendamentoRetroativo.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.feriados = Object.assign(response.data.feriados)
                this.form.datasBloqueadas = Object.assign(response.data.datasBloqueadas)
                this.form.datasComAgendamento = Object.assign(response.data.datasComAgendamento)
                this.form.datas = Object.assign(response.data.datas)
                this.form.dataMinimaValidadeNovoAgendamento = response.data.dataMinimaValidadeNovoAgendamento

                this.showCalendar = true
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        paciente: {type: Object, default: null},
        pacienteId: {type: [Number, String], required: true},
    },
}
</script>